import React from 'react';
interface CtaButtonProps {
  text: string;
  onClick?: () => void;
  href?: string;
  strongPulse?: boolean;
  className?: string;
}
export function CtaButton({
  text,
  onClick,
  href,
  strongPulse = false,
  className = ''
}: CtaButtonProps) {
  const baseClasses = `
    inline-flex items-center justify-center text-center
    w-full md:w-auto min-h-[56px] py-4 px-8 
    bg-crimson hover:bg-crimson-light text-white 
    font-inter font-bold uppercase tracking-wider text-sm md:text-base
    rounded-full shadow-[0_4px_20px_rgba(220,20,60,0.4)]
    transition-colors duration-300
    ${strongPulse ? 'animate-pulse-cta-strong' : 'animate-pulse-cta'}
    ${className}
  `;
  if (href) {
    return <a href={href} className={baseClasses} data-id="element-31">
        {text}
      </a>;
  }
  return <button onClick={onClick} className={baseClasses} data-id="element-32">
      {text}
    </button>;
}